import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../App';
import useOrganizationAccess from '../hooks/useOrganizationAccess';
import usePermissionsMode from '../components/Permissions/usePermissionsMode';
import NRLoadingPage from '../pages/NRLoadingPage/NRLoadingPage';
import NRAccessDenied from '../pages/NRAccessDenied/NRAccessDenied';
import NRAccessError from '../pages/NRAccessDenied/NRAccessError';

const ORG_ACCESS_EXEMPT_PATHS = ['/profile', '/change-password'];

function isOrgAccessExemptPath(pathname) {
  return ORG_ACCESS_EXEMPT_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
}

function NRCheckOrganizationAccess({ children }) {
  const { currentOrgId, isChangingOrg } = useContext(UserContext);
  const { pathname } = useLocation();
  const { isRbacEnabled } = usePermissionsMode();
  const { hasAccess, isInitialLoading, error, refetch } = useOrganizationAccess();

  if (!isRbacEnabled) {
    return children;
  }

  if (!currentOrgId || isChangingOrg || isInitialLoading) {
    return <NRLoadingPage />;
  }

  const isExempt = isOrgAccessExemptPath(pathname);

  if (error && !isExempt) {
    return <NRAccessError onRetry={() => refetch()} />;
  }

  if (!hasAccess && !isExempt) {
    return <NRAccessDenied />;
  }

  return children;
}

export default NRCheckOrganizationAccess;
export { isOrgAccessExemptPath };
